// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";
import { City } from "../stores/types";

interface paramsType {
  id: number;
  notificationID: string | number;
}

export function useCityMutation(
  onSuccessMutation?: (data: City, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function cityById(params: paramsType): Promise<City> {
    const response = await api.get<City>(`admin/cities/${params.id}`);

    if (!response.ok || !response.data) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: cityById,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
